export function joinList(list) {
    switch (list.length) {
        case 0:
            return ""
        case 1:
            return list[0]
        case 2:
            return list[0] + " and " + list[1]
        default:
            return list.slice(0, -1).join(", ") + " and " + list.at(-1)
    }
}
